import React, { useEffect, useState } from "react"
import { apiUrl } from "../../api"
import "./weather.css"

const fallbackHours = [
     { maxtemp: 24, iconday: 3, precipitationProbability: 20, windSpeed: 12, uvIndex: 2 },
     { maxtemp: 25, iconday: 4, precipitationProbability: 24, windSpeed: 13, uvIndex: 2 },
     { maxtemp: 26, iconday: 6, precipitationProbability: 28, windSpeed: 14, uvIndex: 2 },
     { maxtemp: 27, iconday: 32, precipitationProbability: 18, windSpeed: 12, uvIndex: 1 },
     { maxtemp: 28, iconday: 32, precipitationProbability: 12, windSpeed: 10, uvIndex: 1 },
     { maxtemp: 28, iconday: 3, precipitationProbability: 16, windSpeed: 9, uvIndex: 0 },
     { maxtemp: 27, iconday: 12, precipitationProbability: 44, windSpeed: 11, uvIndex: 0 },
     { maxtemp: 26, iconday: 18, precipitationProbability: 58, windSpeed: 14, uvIndex: 0 },
     { maxtemp: 25, iconday: 6, precipitationProbability: 36, windSpeed: 13, uvIndex: 0 },
     { maxtemp: 24, iconday: 34, precipitationProbability: 28, windSpeed: 12, uvIndex: 0 },
     { maxtemp: 23, iconday: 33, precipitationProbability: 24, windSpeed: 10, uvIndex: 0 },
     { maxtemp: 23, iconday: 33, precipitationProbability: 20, windSpeed: 9, uvIndex: 0 }
]

const Weather = () => {
     const [ready, setReady] = useState(fallbackHours)

     useEffect(() => {
          fetch(apiUrl("/controller/weatherhours/"), {
               method: "GET",
          })
               .then((data) => {
                    if (!data.ok) {
                         throw new Error("Weather API unavailable")
                    }
                    return data.json()
               })
               .then((text) => {
                    if (Array.isArray(text) && text.length >= 12) {
                         setReady(text)
                    }
               })
               .catch(() => {
                    setReady(fallbackHours)
               })
     }, [])

     return (
          <div className="weather">
               {ready[11] && (
                    <div className="card auth-card input-field">
                         <div className="weathergrid">
                              {ready.slice(0, 12).map((hour, index) => (
                                   <div key={index} className={`${rowClasses[index]} weatheritem`}>
                                        <span className="hourweathericon">{getIcon(hour.iconday)}</span>
                                        <span className="hourweathertext">
                                             <span className="weathermetrics">
                                                  <span>{hour.maxtemp}&deg;C</span>
                                                  <span>{formatRain(hour.precipitationProbability)}</span>
                                                  <span>{formatWind(hour.windSpeed)}</span>
                                                  <span>{formatUv(hour.uvIndex)}</span>
                                             </span>
                                             <span className="weathertime">{getHourLabel(index)}</span>
                                        </span>
                                   </div>
                              ))}
                         </div>
                    </div>
               )}
          </div>
     )
}

const formatRain = (value) => `${Number(value || 0)}%`

const formatWind = (value) => `${Number(value || 0)} km/h`

const formatUv = (value) => `UV ${Number(value || 0)}`

const getHourLabel = (index) => {
     const date = new Date()
     date.setHours(date.getHours() + index, 0, 0, 0)

     return date.toLocaleTimeString("de-AT", {
          hour: "2-digit",
          minute: "2-digit",
     })
}

const rowClasses = [
     "firstrow",
     "secondrow",
     "thirdrow",
     "forthrow",
     "fiftrow",
     "sixthrow",
     "seventrow",
     "eightrow",
     "ninerow",
     "tenrow",
     "elevenrow",
     "twelferow",
]

const getIcon = (value) => {
     switch (value) {
          case 1:
          case 2:
          case 32:
               return <span className="iconsunny"></span>
          case 3:
          case 4:
               return <span className="iconcloudsandsun"></span>
          case 6:
          case 26:
               return <span className="iconmostlycloudy"></span>
          case 7:
          case 38:
               return <span className="iconcloudy"></span>
          case 12:
               return <span className="iconshowers"></span>
          case 13:
          case 14:
               return <span className="iconmostlycloudywsun"></span>
          case 15:
          case 41:
          case 42:
               return <span className="iconstorm"></span>
          case 16:
          case 17:
               return <span className="iconstormwithsun"></span>
          case 18:
          case 39:
          case 40:
               return <span className="iconrain"></span>
          case 19:
          case 25:
          case 29:
          case 43:
               return <span className="iconflurries"></span>
          case 20:
          case 21:
          case 23:
               return <span className="iconsunwflurries"></span>
          case 22:
          case 24:
          case 31:
               return <span className="iconsnowy"></span>
          case 30:
               return <span className="iconhot"></span>
          case 33:
          case 34:
               return <span className="iconmostlyclear"></span>
          case 35:
          case 36:
               return <span className="iconmostlycloudynight"></span>
          default:
               return <span className="iconcloudy"></span>
     }
}

export default Weather
